import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MainPageApp from './MainPageApp';
import reportWebVitals from './reportWebVitals';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const urlParams = new URLSearchParams(window.location.search);

const renderApp = (container, reactApp) => {
  const shadowContainer = container.attachShadow({mode: 'open'});
  const shadowRootElement = document.createElement('div');
  shadowContainer.appendChild(shadowRootElement);

  const cache = createCache({
    key: 'css',
    prepend: true,
    container: shadowContainer,
  });

  ReactDOM.createRoot(shadowRootElement).render(
    <CacheProvider value={cache}>
      <React.StrictMode>
        {reactApp}
      </React.StrictMode>
    </CacheProvider>
  );
}

if (window.location.pathname === '/') {
  const reactContainer = document.createElement('div');
  reactContainer.setAttribute('id', 'mainpageapp-root');
  document.body.appendChild(reactContainer); // Append it directly to the body

  renderApp(reactContainer, <MainPageApp />);
}
else if (window.location.pathname.startsWith('/lists'))
{
  const reactContainer = document.getElementById('content');
  renderApp(reactContainer, <App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
